// @ts-nocheck
import {
  Toaster as ChakraToaster,
  Portal,
  Stack,
  Toast,
  createToaster,
} from '@chakra-ui/react';
import { X } from 'lucide-react';
import { useScreenLayout } from '../../helpers/utils/useScreenLayout';
import { Button } from './button';
import { pressWash } from './press';
import { TOAST_SURFACE, ToastIconBadge } from './toastSurface';

export const toaster = createToaster({
  placement: 'bottom-end',
  pauseOnPageIdle: true,
});

export const Toaster = () => {
  const layout = useScreenLayout();
  return (
    <Portal>
      <ChakraToaster
        toaster={toaster}
        css={
          layout === 'phone'
            ? undefined
            : {
                left: '50% !important',
                right: 'auto !important',
                transform: 'translateX(-50%)',
                width: '429.6px',
                bottom: '24px !important',
              }
        }
      >
        {(toast) => (
          <Toast.Root
            {...TOAST_SURFACE}
            zoom={layout === 'phone' ? 1 : 1.2}
            gap="12px"
            pl="14px"
            pr={toast.action ? '10px' : '16px'}
            py={toast.action ? '10px' : '14px'}
            alignItems={toast.action ? 'center' : 'flex-start'}
          >
            {toast.indicator ? (
              <Toast.Indicator>{toast.indicator}</Toast.Indicator>
            ) : (
              <ToastIconBadge success={toast.type === 'success'} />
            )}
            <Stack gap="2px" flex="1" minW="1px" lineHeight="1.25">
              {toast.title && (
                <Toast.Title
                  fontSize="var(--spades-font-size-sm)"
                  fontWeight="700"
                  color="var(--spades-ivory)"
                >
                  {toast.title}
                </Toast.Title>
              )}
              {toast.description && (
                <Toast.Description
                  fontSize="var(--spades-font-size-xs)"
                  fontWeight="400"
                  color="var(--spades-muted)"
                >
                  {toast.description}
                </Toast.Description>
              )}
            </Stack>
            {toast.action && (
              <Toast.ActionTrigger asChild>
                <Button
                  variant="secondary"
                  h="44px"
                  minH="44px"
                  minW="84px"
                  px="16px"
                  // Chakra's toast actionTrigger recipe sets its own border
                  // colour, weight and size on this element; the Figma inline
                  // Secondary wins here.
                  borderColor="var(--spades-accent-base)"
                  fontSize="var(--spades-font-size-md)"
                  fontWeight="800"
                >
                  {toast.action.label}
                </Button>
              </Toast.ActionTrigger>
            )}
            {/* 24pt visible box with an invisible 44pt hit area, so the X
                never changes the card's height. */}
            <Toast.CloseTrigger
              aria-label="Dismiss"
              position="relative"
              top="auto"
              insetInlineEnd="auto"
              alignSelf="center"
              flexShrink={0}
              w="24px"
              h="24px"
              p={0}
              borderRadius="var(--spades-radius-sm)"
              color="var(--spades-muted)"
              _hover={{ color: 'var(--spades-ivory)' }}
              css={{
                ...pressWash,
                // Chakra's close-trigger recipe sizes the icon; keep it at 20px.
                '& svg': { width: '20px', height: '20px' },
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  inset: '-10px',
                },
              }}
            >
              <X size={20} />
            </Toast.CloseTrigger>
          </Toast.Root>
        )}
      </ChakraToaster>
    </Portal>
  );
};
